import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketFeesDetailsAC } from './AC/BasketFeesDetails.AC';
import { BasketFeesDetailsOV } from './OV/BasketFeesDetails.OV';
import { BasketFeesDetailsAP } from './AP/BasketFeesDetails.AP';
import { BasketFeesDetailsDS } from './DS/BasketFeesDetails.DS';
import { BasketFeesDetailsOV as BasketFeesDetailsOV_GB } from './OV/GB/BasketFeesDetails.OV';
import { BasketFeesDetailsStyled } from './BasketFeesDetailsStyled';
import { SC } from '../../../styles/theme';

export type BasketFeesDetailsProps = SC & {
    generatedIndex?: number;
};

const BasketFeesDetails = (props: BasketFeesDetailsProps) => {
    if (BRAND === 'AC') return <BasketFeesDetailsAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <BasketFeesDetailsOV_GB {...props} /> : <BasketFeesDetailsOV {...props} />;
    if (BRAND === 'AP') return <BasketFeesDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketFeesDetailsDS {...props} />;
    return <BasketFeesDetailsStyled {...props} />;
};

export default BasketFeesDetails;
